/**
 * Navbar Configuration
 * 
 * Define menu items, submenus, and anchor scroll behavior.
 * 
 * Structure:
 * - label: Display text (will be uppercased)
 * - to: Route path (for Link navigation)
 * - submenu: Optional array of submenu items
 *   - label: Display text
 *   - anchorId: ID of element to scroll to
 *   - anchorPage: Route where the anchor exists (default: '/')
 *   - onClick: Optional custom click handler
 */

export const navbarConfig = [
  {
    label: 'Inicio',
    to: '/',
    submenu: [
      {
        label: 'Cómo funciona',
        anchorId: 'como-funciona',
        anchorPage: '/',
      },
    ],
  },
  {
    label: 'Sobre Nosotros',
    to: '/sobre-huelmu',
  },
  {
    label: 'Contacto',
    to: '/contacto',
  },
  // Add more menu items here as needed
  // Example:
  // {
  //   label: 'Productos',
  //   to: '/productos',
  //   submenu: [
  //     {
  //       label: 'Ver todos',
  //       anchorId: 'productos-list',
  //       anchorPage: '/productos',
  //     },
  //   ],
  // },
];

